var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9415 7.73271C16.2271 8.03263 16.2156 8.50737 15.9157 8.79306L10.6652 13.7944C10.3755 14.0703 9.92031 14.0703 9.63064 13.7944L4.38017 8.79306C4.08025 8.50737 4.06871 8.03263 4.35441 7.73271C4.6401 7.43279 5.11483 7.42125 5.41475 7.70694L10.1479 12.2155L14.8811 7.70694C15.181 7.42125 15.6558 7.43279 15.9415 7.73271Z",
    fill: "#0E0E0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.63e263d77c60f7b97b3ee968fe102f64.svg";
export { ForwardRef as ReactComponent };